import { addSimpleNotification } from '@notifications/actions'
import type { ProjectElementInfo } from 'common/types'

export const notifyNotElementsNotDeleted = (data: ProjectElementInfo[]) => {
  const isElementChecked = data.some(elementInfo =>
    elementInfo.tabElements.some(tabElement => tabElement.state === 'Checked'),
  )

  addSimpleNotification({
    message: isElementChecked ? 'Элемент в активном состоянии' : 'Элемент не удален',
    autoClose: 10,
  })
}
